import MoreWorkSimplePage from 'pages/notification/insight/more-work-simple/page'
import UndesiredWorkConditionPage from 'pages/notification/insight/undesired-work-condition/page'

import OnboardingQuestionnairePage from '../pages/notification/insight/onboarding-questionnaire/page'

export const insightsRoutes = [
  {
    path: '/insight/more-work-simple',
    element: <MoreWorkSimplePage />,
  },
  {
    path: '/insight/undesired-work-condition',
    element: <UndesiredWorkConditionPage />,
  },
  {
    path: '/insight/onboarding-questionnaire',
    element: <OnboardingQuestionnairePage />,
  },
]
